import { cloneElement, Children } from 'react';
import { useMenuContext } from './VizExMenu';
const VizExMenuTrigger = ({
  children
}) => {
  const {
    isOpen,
    toggle,
    triggerRef
  } = useMenuContext();
  return /*#__PURE__*/cloneElement(Children.only(children), {
    ref: triggerRef,
    'aria-haspopup': 'menu',
    'aria-expanded': isOpen,
    onClick: e => {
      var _children$props$onCli, _children$props;
      (_children$props$onCli = (_children$props = children.props).onClick) === null || _children$props$onCli === void 0 || _children$props$onCli.call(_children$props, e);
      toggle();
    }
  });
};
VizExMenuTrigger.displayName = 'VizExMenuTrigger';
export default VizExMenuTrigger;